/* ==========================================================================
   Google Consent Mode v2 & GDPR Cookie Management Component
   Supports: "Odmítnout volitelné", "Nastavení", "Přijmout vše"
   Categories: Nezbytné, Analytické (GA4), Externí média (YouTube)
   100% Multi-Language i18n (CS, EN, DE, ES, PT, AR) with full RTL support
   ========================================================================== */

import { getLocale } from '../locales/i18n.js';

export const cookieTranslations = {
  cs: {
    bannerTitle: '🍪 Nastavení ochrany soukromí a cookies',
    bannerText: 'Používáme soubory cookie a analytické technologie k zajištění správného fungování webu, měření návštěvnosti a zobrazení externího obsahu. Můžete přijmout vše, odmítnout volitelné technologie nebo si upravit nastavení jednotlivých kategorií.',
    learnMore: 'Více v Zásadách používání cookies',
    acceptAll: 'Přijmout vše',
    rejectAll: 'Odmítnout volitelné',
    settingsBtn: 'Nastavení',
    modalTitle: 'Předvolby souborů cookie',
    modalDesc: 'Zvolte, které typy technologií nám povolíte zpracovávat. Nezbytné technologie jsou nutné pro technické fungování stránek a nelze je vypnout.',
    necessaryTitle: 'Nezbytné technologie',
    necessaryBadge: 'Vždy aktivní',
    necessaryDesc: 'Tyto technologie a místní úložiště slouží k základnímu fungování webu, uložení zvoleného jazyka a zapamatování vašeho nastavení ochrany soukromí.',
    analyticsTitle: 'Analytické cookies (Google Analytics 4)',
    analyticsDesc: 'Po udělení souhlasu pomáhají statisticky vyhodnocovat návštěvnost a způsob používání webu bez ukládání citlivých osobních údajů.',
    externalMediaTitle: 'Externí média (YouTube)',
    externalMediaDesc: 'Umožňují přehrávat vložená videa služby YouTube v režimu se zvýšenou ochranou soukromí. Bez vašeho souhlasu se načte pouze náhled.',
    savePreferences: 'Uložit nastavení',
    close: 'Zavřít'
  },
  en: {
    bannerTitle: '🍪 Privacy & Cookie Preferences',
    bannerText: 'We use cookies and analytics technologies to ensure proper website functionality, measure traffic, and display external media. You can accept all, reject optional technologies, or customize category settings.',
    learnMore: 'Learn more in our Cookie Policy',
    acceptAll: 'Accept All',
    rejectAll: 'Decline Optional',
    settingsBtn: 'Settings',
    modalTitle: 'Cookie Consent Preferences',
    modalDesc: 'Choose which technology categories you allow us to use. Strictly necessary technologies are required for the technical operation of the website and cannot be disabled.',
    necessaryTitle: 'Strictly Necessary Technologies',
    necessaryBadge: 'Always Active',
    necessaryDesc: 'Essential for core website operation, language selection memory, and privacy preferences.',
    analyticsTitle: 'Analytics Cookies (Google Analytics 4)',
    analyticsDesc: 'Help us statistically analyze traffic and visitor interactions without storing sensitive personal data.',
    externalMediaTitle: 'External Media (YouTube)',
    externalMediaDesc: 'Enables playback of embedded YouTube videos in privacy-enhanced mode. Without consent, only a preview is shown.',
    savePreferences: 'Save Preferences',
    close: 'Close'
  },
  de: {
    bannerTitle: '🍪 Datenschutz- & Cookie-Einstellungen',
    bannerText: 'Wir verwenden Cookies und Analysetechnologien, um die ordnungsgemäße Funktion der Website sicherzustellen, den Datenverkehr zu messen und externe Medien anzuzeigen.',
    learnMore: 'Mehr erfahren in unserer Cookie-Richtlinie',
    acceptAll: 'Alle akzeptieren',
    rejectAll: 'Optionale ablehnen',
    settingsBtn: 'Einstellungen',
    modalTitle: 'Cookie-Präferenzen anpassen',
    modalDesc: 'Wählen Sie aus, welche Kategorien Sie zulassen möchten. Notwendige Technologien sind für den technischen Betrieb erforderlich.',
    necessaryTitle: 'Notwendige Technologien',
    necessaryBadge: 'Immer aktiv',
    necessaryDesc: 'Erforderlich für Kernfunktionen, Sicherheit, Sprachauswahl und Speicherung Ihrer Datenschutzeinstellungen.',
    analyticsTitle: 'Analyse-Cookies (Google Analytics 4)',
    analyticsDesc: 'Helfen uns zu verstehen, wie Besucher die Website nutzen, ohne sensible persönliche Daten zu speichern.',
    externalMediaTitle: 'Externe Medien (YouTube)',
    externalMediaDesc: 'Ermöglicht das Abspielen eingebetteter YouTube-Videos im erweiterten Datenschutzmodus.',
    savePreferences: 'Einstellungen speichern',
    close: 'Schließen'
  },
  es: {
    bannerTitle: '🍪 Privacidad y Preferencias de Cookies',
    bannerText: 'Utilizamos cookies y tecnologías analíticas para garantizar el correcto funcionamiento del sitio web, medir el tráfico y mostrar medios externos.',
    learnMore: 'Más información en nuestra Política de Cookies',
    acceptAll: 'Aceptar todo',
    rejectAll: 'Rechazar opcionales',
    settingsBtn: 'Configuración',
    modalTitle: 'Preferencias de Consentimiento de Cookies',
    modalDesc: 'Elija qué categorías de tecnologías nos permite utilizar. Las tecnologías necesarias no se pueden desactivar.',
    necessaryTitle: 'Tecnologías Necesarias',
    necessaryBadge: 'Siempre activo',
    necessaryDesc: 'Esenciales para el funcionamiento básico, la selección de idioma y el almacenamiento de sus preferencias de privacidad.',
    analyticsTitle: 'Cookies Analíticas (Google Analytics 4)',
    analyticsDesc: 'Nos ayudan a evaluar estadísticamente el tráfico web sin almacenar datos personales sensibles.',
    externalMediaTitle: 'Medios Externos (YouTube)',
    externalMediaDesc: 'Permite reproducir videos de YouTube integrados en modo de privacidad mejorada.',
    savePreferences: 'Guardar preferencias',
    close: 'Cerrar'
  },
  pt: {
    bannerTitle: '🍪 Privacidade e Preferências de Cookies',
    bannerText: 'Utilizamos cookies e tecnologias analíticas para garantir o correto funcionamento do site, medir o tráfego e exibir mídia externa.',
    learnMore: 'Saiba mais na nossa Política de Cookies',
    acceptAll: 'Aceitar tudo',
    rejectAll: 'Rejeitar opcionais',
    settingsBtn: 'Configurações',
    modalTitle: 'Preferências de Consentimento de Cookies',
    modalDesc: 'Escolha quais categorias de tecnologias nos permite utilizar. As tecnologias necessárias não podem ser desativadas.',
    necessaryTitle: 'Tecnologias Necessárias',
    necessaryBadge: 'Sempre ativo',
    necessaryDesc: 'Essenciais para o funcionamento básico, seleção de idioma e armazenamento das suas preferências de privacidade.',
    analyticsTitle: 'Cookies Analíticos (Google Analytics 4)',
    analyticsDesc: 'Ajudam-nos a avaliar estatisticamente o tráfego do site sem armazenar dados pessoais confidenciais.',
    externalMediaTitle: 'Mídia Externa (YouTube)',
    externalMediaDesc: 'Permite reproduzir vídeos incorporados do YouTube em modo de privacidade aprimorada.',
    savePreferences: 'Salvar preferências',
    close: 'Fechar'
  },
  ar: {
    bannerTitle: '🍪 الخصوصية وتفضيلات ملفات تعريف الارتباط',
    bannerText: 'نستخدم ملفات تعريف الارتباط والتقنيات التحليلية لضمان عمل الموقع وقياس الزيارات وعرض الوسائط الخارجية. يمكنك قبول الكل أو رفض الاختيارية أو تخصيص الإعدادات.',
    learnMore: 'المزيد في سياسة ملفات تعريف الارتباط',
    acceptAll: 'قبول الكل',
    rejectAll: 'رفض الاختيارية',
    settingsBtn: 'الإعدادات',
    modalTitle: 'تفضيلات ملفات تعريف الارتباط',
    modalDesc: 'اختر فئات التقنيات التي تسمح لنا باستخدامها. لا يمكن تعطيل التقنيات الضرورية لتشغيل الموقع.',
    necessaryTitle: 'التقنيات الضرورية',
    necessaryBadge: 'نشط دائمًا',
    necessaryDesc: 'ضرورية للأداء الأساسي للموقع وتذكر اللغة وتفضيلات الخصوصية.',
    analyticsTitle: 'ملفات تعريف الارتباط التحليلية (Google Analytics 4)',
    analyticsDesc: 'تساعدنا على تحليل حركة المرور إحصائياً دون تخزين بيانات شخصية حساسة.',
    externalMediaTitle: 'الوسائط الخارجية (YouTube)',
    externalMediaDesc: 'تتيح تشغيل فيديوهات YouTube المضمنة في وضع الخصوصية المحسنة.',
    savePreferences: 'حفظ الإعدادات',
    close: 'إغلاق'
  }
};

/**
 * Get current saved consent object or null
 */
export function getSavedConsent() {
  try {
    const raw = localStorage.getItem('sed_cookie_consent_v2');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return {
      necessary: true,
      analytics: Boolean(parsed.analytics),
      externalMedia: Boolean(parsed.externalMedia ?? parsed.marketing),
      timestamp: parsed.timestamp || new Date().toISOString()
    };
  } catch (e) {
    return null;
  }
}

/**
 * Check whether a specific category has consent
 */
export function hasConsent(category) {
  if (category === 'necessary') return true;
  const consent = getSavedConsent();
  if (!consent) return false;
  return Boolean(consent[category]);
}

/**
 * Update Google Consent Mode v2 State and notify dataLayer & listeners
 */
export function updateConsentState({ analytics, externalMedia }) {
  const analyticsGranted = Boolean(analytics);
  const externalMediaGranted = Boolean(externalMedia);

  const consentObject = {
    analytics_storage: analyticsGranted ? 'granted' : 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied'
  };

  // 1. Send update command to gtag
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', consentObject);
  }

  // 2. Push consent_updated event to dataLayer
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'consent_updated',
    consent_analytics: consentObject.analytics_storage,
    consent_ad_storage: 'denied',
    consent_external_media: externalMediaGranted ? 'granted' : 'denied'
  });

  // 3. Persist user selection
  const storedData = {
    necessary: true,
    analytics: analyticsGranted,
    externalMedia: externalMediaGranted,
    timestamp: new Date().toISOString()
  };
  localStorage.setItem('sed_cookie_consent_v2', JSON.stringify(storedData));

  // 4. Dispatch custom event for reactive UI components (e.g. YouTubeLazyEmbed)
  window.dispatchEvent(new CustomEvent('sed:consentChange', { detail: storedData }));
}

/**
 * Legacy alias for backwards compatibility
 */
export function updateGoogleConsentMode(analyticsGranted, marketingGranted) {
  updateConsentState({
    analytics: analyticsGranted,
    externalMedia: marketingGranted
  });
}

/**
 * Open the detailed Cookie Settings Modal
 */
export function openCookieSettings(onNavigate) {
  const lang = getLocale() || 'en';
  const t = cookieTranslations[lang] || cookieTranslations.en;
  const isRtl = lang === 'ar';
  const current = getSavedConsent() || { necessary: true, analytics: false, externalMedia: false };

  // Remove existing modal if any
  const existing = document.getElementById('sed-cookie-settings-modal');
  if (existing) existing.remove();

  const modalOverlay = document.createElement('div');
  modalOverlay.id = 'sed-cookie-settings-modal';
  modalOverlay.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(3, 14, 28, 0.85);
    backdrop-filter: blur(8px);
    z-index: 100000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    box-sizing: border-box;
    direction: ${isRtl ? 'rtl' : 'ltr'};
  `;

  modalOverlay.innerHTML = `
    <div style="
      background: #07192f;
      border: 1px solid rgba(53, 168, 223, 0.3);
      box-shadow: 0 20px 50px rgba(0,0,0,0.6);
      border-radius: 14px;
      max-width: 620px;
      width: 100%;
      max-height: 90vh;
      display: flex;
      flex-direction: column;
      color: #ffffff;
      font-family: var(--font-body, system-ui, sans-serif);
      overflow: hidden;
      text-align: ${isRtl ? 'right' : 'left'};
    ">
      <!-- Modal Header -->
      <div style="padding: 1.5rem 1.75rem 1rem; border-bottom: 1px solid rgba(255,255,255,0.1); display: flex; justify-content: space-between; align-items: center;">
        <h3 style="margin: 0; font-size: 1.25rem; font-weight: 800; color: #ffffff; display: flex; align-items: center; gap: 8px;">
          <span>🍪</span> ${t.modalTitle}
        </h3>
        <button id="sed-cookie-modal-close-btn" style="background: none; border: none; color: rgba(255,255,255,0.7); font-size: 1.5rem; cursor: pointer; line-height: 1; padding: 0.25rem;" title="${t.close}">&times;</button>
      </div>

      <!-- Modal Body -->
      <div style="padding: 1.5rem 1.75rem; overflow-y: auto; flex: 1; display: flex; flex-direction: column; gap: 1.25rem;">
        <p style="margin: 0; font-size: 0.88rem; line-height: 1.6; color: rgba(255,255,255,0.85);">
          ${t.modalDesc}
        </p>

        <!-- Category 1: Strictly Necessary -->
        <div style="background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 1rem 1.25rem;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.4rem;">
            <div style="font-weight: 700; font-size: 0.95rem; color: #ffffff;">${t.necessaryTitle}</div>
            <span style="background: rgba(53, 168, 223, 0.2); color: #35a8df; font-size: 0.72rem; font-weight: 800; padding: 0.2rem 0.6rem; border-radius: 4px;">${t.necessaryBadge}</span>
          </div>
          <p style="margin: 0; font-size: 0.82rem; line-height: 1.5; color: rgba(255,255,255,0.65);">${t.necessaryDesc}</p>
        </div>

        <!-- Category 2: Analytics -->
        <div style="background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 1rem 1.25rem;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.4rem;">
            <label for="sed-cookie-toggle-analytics" style="font-weight: 700; font-size: 0.95rem; color: #ffffff; cursor: pointer; display: flex; align-items: center; gap: 8px;">
              ${t.analyticsTitle}
            </label>
            <input type="checkbox" id="sed-cookie-toggle-analytics" ${current.analytics ? 'checked' : ''} style="width: 18px; height: 18px; cursor: pointer; accent-color: #35a8df;" />
          </div>
          <p style="margin: 0; font-size: 0.82rem; line-height: 1.5; color: rgba(255,255,255,0.65);">${t.analyticsDesc}</p>
        </div>

        <!-- Category 3: External Media (YouTube) -->
        <div style="background: rgba(255,255,255,0.04); border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; padding: 1rem 1.25rem;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.4rem;">
            <label for="sed-cookie-toggle-external" style="font-weight: 700; font-size: 0.95rem; color: #ffffff; cursor: pointer; display: flex; align-items: center; gap: 8px;">
              ${t.externalMediaTitle}
            </label>
            <input type="checkbox" id="sed-cookie-toggle-external" ${current.externalMedia ? 'checked' : ''} style="width: 18px; height: 18px; cursor: pointer; accent-color: #35a8df;" />
          </div>
          <p style="margin: 0; font-size: 0.82rem; line-height: 1.5; color: rgba(255,255,255,0.65);">${t.externalMediaDesc}</p>
        </div>

        <div>
          <a href="#cookie-policy" id="sed-cookie-policy-link" style="color: #35a8df; font-size: 0.82rem; text-decoration: underline;">${t.learnMore} →</a>
        </div>
      </div>

      <!-- Modal Footer Action Buttons -->
      <div style="padding: 1.25rem 1.75rem; border-top: 1px solid rgba(255,255,255,0.1); display: flex; gap: 0.75rem; justify-content: flex-end; flex-wrap: wrap; background: rgba(0,0,0,0.2);">
        <button id="sed-cookie-modal-reject" class="sed-btn sed-cookie-btn-reject" style="font-size: 0.85rem; padding: 0.55rem 1.1rem; background-color: transparent !important; color: #ffffff !important; border: 1.5px solid rgba(255,255,255,0.45) !important;">${t.rejectAll}</button>
        <button id="sed-cookie-modal-save" class="sed-btn sed-cookie-btn-settings" style="font-size: 0.85rem; padding: 0.55rem 1.2rem; background-color: rgba(53, 168, 223, 0.15) !important; color: #35a8df !important; border: 1.5px solid #35a8df !important; font-weight: 700 !important;">${t.savePreferences}</button>
        <button id="sed-cookie-modal-accept-all" class="sed-btn sed-cookie-btn-accept" style="font-size: 0.85rem; padding: 0.55rem 1.2rem; background-color: #10b981 !important; border: 1.5px solid #10b981 !important; color: #ffffff !important; font-weight: 700 !important;">${t.acceptAll}</button>
      </div>
    </div>
  `;

  document.body.appendChild(modalOverlay);

  const closeModal = () => {
    modalOverlay.remove();
    const banner = document.getElementById('sed-cookie-banner-root');
    if (banner) banner.remove();
  };

  document.getElementById('sed-cookie-modal-close-btn').addEventListener('click', closeModal);
  modalOverlay.addEventListener('click', (e) => {
    if (e.target === modalOverlay) closeModal();
  });

  document.getElementById('sed-cookie-modal-reject').addEventListener('click', () => {
    updateConsentState({ analytics: false, externalMedia: false });
    closeModal();
  });

  document.getElementById('sed-cookie-modal-save').addEventListener('click', () => {
    const analytics = document.getElementById('sed-cookie-toggle-analytics').checked;
    const externalMedia = document.getElementById('sed-cookie-toggle-external').checked;
    updateConsentState({ analytics, externalMedia });
    closeModal();
  });

  document.getElementById('sed-cookie-modal-accept-all').addEventListener('click', () => {
    updateConsentState({ analytics: true, externalMedia: true });
    closeModal();
  });

  const policyLink = document.getElementById('sed-cookie-policy-link');
  if (policyLink) {
    policyLink.addEventListener('click', (e) => {
      e.preventDefault();
      closeModal();
      if (typeof onNavigate === 'function') {
        onNavigate('cookie-policy');
      } else {
        window.location.hash = 'cookie-policy';
      }
    });
  }
}

/**
 * Render the Global 3-Option Cookie Banner
 */
export function renderCookieBanner(onNavigate) {
  const existing = document.getElementById('sed-cookie-banner-root');
  if (existing) existing.remove();

  // If consent is already stored, do not display the initial banner
  if (getSavedConsent()) return;

  const lang = getLocale() || 'en';
  const t = cookieTranslations[lang] || cookieTranslations.en;
  const isRtl = lang === 'ar';

  const banner = document.createElement('div');
  banner.id = 'sed-cookie-banner-root';
  banner.style.cssText = `
    position: fixed;
    bottom: 20px;
    left: 20px;
    right: 20px;
    max-width: 1100px;
    margin: 0 auto;
    background: rgba(7, 25, 47, 0.95);
    border: 1px solid rgba(53, 168, 223, 0.35);
    border-radius: 12px;
    box-shadow: 0 16px 40px rgba(0,0,0,0.5);
    backdrop-filter: blur(12px);
    z-index: 99999;
    padding: 1.25rem 1.5rem;
    color: #ffffff;
    font-family: var(--font-body, system-ui, sans-serif);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    box-sizing: border-box;
    animation: sedFadeInUp 0.3s ease-out;
    direction: ${isRtl ? 'rtl' : 'ltr'};
    text-align: ${isRtl ? 'right' : 'left'};
  `;

  banner.innerHTML = `
    <div style="display: flex; flex-direction: column; gap: 0.5rem;">
      <div style="font-weight: 800; font-size: 1.05rem; color: #ffffff; display: flex; align-items: center; gap: 8px;">
        ${t.bannerTitle}
      </div>
      <div style="font-size: 0.88rem; line-height: 1.55; color: rgba(255,255,255,0.85);">
        ${t.bannerText}
        <a href="#cookie-policy" id="sed-banner-policy-link" style="color: #35a8df; text-decoration: underline; margin-left: 6px; margin-right: 6px; white-space: nowrap;">${t.learnMore}</a>
      </div>
    </div>

    <!-- 3 Action Choices: Reject Optional, Settings, Accept All -->
    <div style="display: flex; gap: 0.65rem; justify-content: flex-end; align-items: center; flex-wrap: wrap;">
      <button id="sed-cookie-btn-reject" class="sed-btn sed-cookie-btn-reject" style="font-size: 0.85rem; padding: 0.5rem 1.1rem; background-color: transparent !important; color: #ffffff !important; border: 1.5px solid rgba(255,255,255,0.45) !important;">${t.rejectAll}</button>
      <button id="sed-cookie-btn-settings" class="sed-btn sed-cookie-btn-settings" style="font-size: 0.85rem; padding: 0.5rem 1.1rem; background-color: transparent !important; color: #35a8df !important; border: 1.5px solid rgba(53, 168, 223, 0.7) !important; font-weight: 600;">⚙️ ${t.settingsBtn}</button>
      <button id="sed-cookie-btn-accept" class="sed-btn sed-cookie-btn-accept" style="font-size: 0.85rem; padding: 0.5rem 1.25rem; background-color: #35a8df !important; color: #ffffff !important; border: 1.5px solid #35a8df !important; font-weight: 700 !important;">${t.acceptAll}</button>
    </div>
  `;

  document.body.appendChild(banner);

  document.getElementById('sed-cookie-btn-accept').addEventListener('click', () => {
    updateConsentState({ analytics: true, externalMedia: true });
    banner.remove();
  });

  document.getElementById('sed-cookie-btn-reject').addEventListener('click', () => {
    updateConsentState({ analytics: false, externalMedia: false });
    banner.remove();
  });

  document.getElementById('sed-cookie-btn-settings').addEventListener('click', () => {
    openCookieSettings(onNavigate);
  });

  const policyLink = document.getElementById('sed-banner-policy-link');
  if (policyLink) {
    policyLink.addEventListener('click', (e) => {
      e.preventDefault();
      if (typeof onNavigate === 'function') {
        onNavigate('cookie-policy');
      } else {
        window.location.hash = 'cookie-policy';
      }
    });
  }
}
